export default {
  'Difficulty level': 'Vanskelighetsgrad',
  'Your bet': 'Innsatsbeløp',
  'Start game': 'Spill',
  'Take prize': 'Ta',
  'Try again': 'Prøv igjen',
  Profit: 'Overskudd',
};
